import { useHistory } from "react-router-dom";
import { Arrow } from "../images/Arrow";

interface IArrowButton {
    path: string;
}

export const ArrowButon = (props: IArrowButton) => {
    const history = useHistory();

    const backHistory = () => {
        history.push(props.path)
    }
    return (
        <button
        style={{
            background: 'transparent',
            border: '0',
            marginLeft: '10px'
        }} 
        onClick={backHistory}>
            <Arrow />
        </button>
    )
}